import React from 'react';
import FilterableSelect from '../../../../../../common/components/FilterableSelect/FilterableSelect';
import {
  generateBasicStructure,
  nameById,
} from '@mm/state/helpers/filterable-select-helpers';
import { AccountErrorTooltip } from '../../../../../../common/components/AccountErrorTooltip/AccountErrorTooltip';
import AdAccountModel from '@mm/state/model/AdAccountModel';
import AdConfigModel from '@mm/state/model/AdConfigModel';
import classNames from 'classnames';

type Props = {
  formValues: { adAccount: AdAccountModel | null };
  accounts: AdAccountModel[];
  onChange: (id: string) => void;
  adConfig: AdConfigModel | null;
  validations?: string[];
  usedInSlideout?: boolean;
};

export const AdAccountStep = (props: Props) => {
  const {
    formValues,
    adConfig,
    accounts,
    validations,
    onChange,
    usedInSlideout,
  } = props;
  const draft = adConfig?.draft;
  const inProgress = adConfig?.publishingProcess;
  const disabled = !adConfig || !draft || inProgress;

  return (
    <div className="ad-detail__inputs-container">
      <div
        className={classNames('ad-detail__input-container', {
          'ad-detail__input-container-slideout': usedInSlideout,
        })}
      >
        <div className="ad-config-detail__ad-account-selector ad-detail__selector">
          <FilterableSelect
            className="ad-detail-detail__filterable-select"
            onChange={onChange}
            outerValue={nameById(
              formValues.adAccount?.id || '',
              accounts.map(account => ({
                ...account,
                id: Number(account.id),
              })),
              adConfig?.adAccountId
                ? `${adConfig.adAccountName} (Access restricted)`
                : 'No Ad Account',
            )}
            suggestions={generateBasicStructure(accounts)}
            placeholder="Select Ad Account"
            disabled={disabled}
          />
          <AccountErrorTooltip
            classPrefix="ad-detail"
            hasAccounts={accounts.length > 0}
            validation={validations}
          />
        </div>
      </div>
    </div>
  );
};
